import { DateTime } from 'luxon'
import { datadogLogs } from '@datadog/browser-logs'

export const PLAID_CONNECT_REMINDER_STORAGE_KEY =
  'bankingPlaidConnectReminderDismissedAt'

const SUPPRESSION_HOURS = 24

const logSuppressionWarning = (action: string, err: unknown): void => {
  datadogLogs.logger.warn(
    `Plaid connect reminder suppression: ${action} failed`,
    { error: err instanceof Error ? err.message : String(err) }
  )
}

export const setPlaidConnectReminderSuppressed = (): void => {
  try {
    localStorage.setItem(
      PLAID_CONNECT_REMINDER_STORAGE_KEY,
      DateTime.now().toJSON()
    )
  } catch (err) {
    logSuppressionWarning('write', err)
  }
}

export const isPlaidConnectReminderSuppressed = (): boolean => {
  let raw: string | null
  try {
    raw = localStorage.getItem(PLAID_CONNECT_REMINDER_STORAGE_KEY)
  } catch (err) {
    logSuppressionWarning('read', err)
    return false
  }
  if (!raw) return false
  const dismissedAt = DateTime.fromISO(raw)
  if (!dismissedAt.isValid) return false
  return dismissedAt.plus({ hours: SUPPRESSION_HOURS }) > DateTime.now()
}

export const clearPlaidConnectReminderSuppression = (): void => {
  try {
    localStorage.removeItem(PLAID_CONNECT_REMINDER_STORAGE_KEY)
  } catch (err) {
    logSuppressionWarning('clear', err)
  }
}
